import React from 'react';

export const ModalClose = (props) => {
    return(
        <div className={props.divStyle} id="js-close-btn" onClick={props.onClick}>
            <svg className={props.svgStyle}>
                <polyline stroke="#A5A5A5" strokeWidth="2px" points="0,0 20,20" fill="none" />
                <polyline stroke="#A5A5A5" strokeWidth="2px" points="20,0 0,20" fill="none" />
            </svg>
        </div>
    );
}